/**
 * @file: AiEditionTabScreens.ts
 * @copyright: (c) 2019-2020 sichuan zhichetech co., ltd.
 */

import { AiSuitePage } from '@euler/app/flows/ai-suite/AiSuitePage';
import { ApdmDashboardPage } from '@euler/app/flows/apdm/dashboard/ApdmDashboardPage';
import { BiDashboardListPage } from '@euler/app/flows/bi-dashboards/BiDashboardListPage';
import { BiDashboardPage } from '@euler/app/flows/bi-dashboards/BiDashboardPage';
import { BiExportListPage } from '@euler/app/flows/bi-dashboards/BiExportListPage';
import { BiHomePage } from '@euler/app/flows/bi-dashboards/BiHomePage';
import { CoachingFlow } from '@euler/app/flows/coaching';
import { withStoreFeature } from '@euler/components/entitlements/withStoreFeature';
import { StoreFeature } from '@euler/model/enum';
import { aiEditionTabStack } from './AiEditionTabStack';

/** The tab screens of the AI edition, each gated by what it is sold for. */
export const kAiEditionTabScreens = {
  AiHome: withStoreFeature(AiSuitePage, StoreFeature.AiAssistant),
  AiMarketing: withStoreFeature(
    aiEditionTabStack(
      '私域营销',
      { ApdmDashboard: ApdmDashboardPage },
      'ApdmDashboard',
    ),
    StoreFeature.Apdm,
  ),
  AiDashboards: withStoreFeature(
    aiEditionTabStack(
      '数据看板',
      {
        BiHome: BiHomePage,
        BiDashboards: BiDashboardListPage,
        BiDashboard: BiDashboardPage,
        BiExports: BiExportListPage,
      },
      'BiHome',
    ),
    StoreFeature.Bi,
  ),
  AiCoaching: withStoreFeature(CoachingFlow, StoreFeature.Coaching),
};
